/**
 * Returns a user-facing validation error when the trimmed name is empty or at least 50 characters long.
 *
 * @returns Error message, or `null` when the name is acceptable.
 */
export function validateTreeName(name: string): string | null {
  const trimmed = name.trim();
  if (trimmed.length === 0) {
    return 'Tree name cannot be blank';
  }
  if (trimmed.length >= 50) {
    return 'Tree name must be less than 50 characters';
  }
  return null;
}
